import { render } from "./RequestOffer.vue?vue&type=template&id=b5a5721e&scoped=true"
import script from "./RequestOffer.vue?vue&type=script&lang=js"
export * from "./RequestOffer.vue?vue&type=script&lang=js"

import "./RequestOffer.vue?vue&type=style&index=0&id=b5a5721e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a5721e"]])

export default __exports__